/**
 * Utility to detect rate limit errors from various error message formats
 * 
 * @deprecated Use detectRateLimit from '@/lib/rateLimit/detection' instead
 * This is kept for backward compatibility
 */

import { isRateLimitMessage } from '@/lib/rateLimit/detection';

/**
 * Checks if an error message indicates a rate limit error
 * @param errorMessage - The error message to check
 * @returns true if the error is a rate limit error
 * @deprecated Use isRateLimitMessage from '@/lib/rateLimit/detection' instead
 */
export function isRateLimitError(errorMessage: string): boolean {
    return isRateLimitMessage(errorMessage);
}

/**
 * Extracts the original error message text, removing markdown formatting
 * @param content - The message content that may contain error text
 * @returns The cleaned error message or null if not an error
 */
export function extractErrorMessage(content: string): string | null {
    if (!content || typeof content !== 'string') {
        return null;
    }

    // Match patterns like "*Stream Error: ...*" or "Error: ..."
    const streamErrorMatch = content.match(/\*Stream Error:\s*(.+?)\*/i);
    if (streamErrorMatch) {
        return streamErrorMatch[1].trim();
    }

    const errorMatch = content.match(/^Error:\s*(.+)/i);
    if (errorMatch) {
        return errorMatch[1].trim();
    }

    return null;
}
